import { FC } from 'react';
import { Theme, css } from '@emotion/react';
import { computeEnv } from 'settings/AppSettings';
import { muiPaletteColors } from 'theme/colors/omakaseColors';
import { useIsSsr } from 'hooks/useIsSsr';

export const SiteInfo: FC = () => {
  // isSsr hook protects against undefined `window` on the server
  const isSsr = useIsSsr();
  if (isSsr) {
    return null;
  }

  const envName = computeEnv(__ENV__);
  if (!envName || envName === 'prod') {
    return null;
  }

  const buildNo = window.__BUILD_NUMBER__ || '';

  const envTagStyles = ({ borderRadius }: Theme) => css`
    background-color: ${muiPaletteColors.MuiPalettePrimary};
    border-radius: ${borderRadius[100]};
    color: #fff;
    font-size: 1.4rem;
    margin-left: 1.2rem;
    padding: 0.6rem 0.9rem;
  `;

  return (
    <div css={envTagStyles} data-testid="env-version-chip">
      {envName.charAt(0).toUpperCase() + envName.slice(1)}{' '}
      {buildNo && (
        <>
          v<small data-testid="front-end-ver">{buildNo}</small>
        </>
      )}
    </div>
  );
};
